import { render, staticRenderFns } from "./CategoryTagIds.vue?vue&type=template&id=59113d44&"
import script from "./CategoryTagIds.vue?vue&type=script&lang=ts&"
export * from "./CategoryTagIds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports